import { render, staticRenderFns } from "./ResearchReport.vue?vue&type=template&id=d5eedd9a&scoped=true&"
import script from "./ResearchReport.vue?vue&type=script&lang=js&"
export * from "./ResearchReport.vue?vue&type=script&lang=js&"
import style0 from "./ResearchReport.vue?vue&type=style&index=0&id=d5eedd9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5eedd9a",
  null
  
)

export default component.exports